import React from "react";
import PostImage from "../Post/PostImage";
import PostHeader from "../Post/PostHeader";
import PostContent from "../Post/PostContent";
import PostFooter from "../Post/PostFooter";

const ModalPostCardData = (props) => {
    return (
        <>
            <PostHeader
                engagement={true}
                data={props.data}
                postData={props.postData}
                downloadParentPostCsv={props.downloadParentPostCsv}
                setPostSentiment={props.setPostSentiment}
                setCommentSentiment={props.setCommentSentiment}
                company={props.company}
                postIndex={props.postIndex}
                updatePostAfterSentimentUpdate={props.updatePostAfterSentimentUpdate}
            />
            <PostImage
                data={props.data}
                postData={props.postData}
                downloadParentPostCsv={props.downloadParentPostCsv}
                setPostSentiment={props.setPostSentiment}
                setCommentSentiment={props.setCommentSentiment}
                company={props.company}
                postIndex={props.postIndex}
                updatePostAfterSentimentUpdate={props.updatePostAfterSentimentUpdate}
            />
            <PostContent
                data={props.data}
                postData={props.postData}
                downloadParentPostCsv={props.downloadParentPostCsv}
                setPostSentiment={props.setPostSentiment}
                setCommentSentiment={props.setCommentSentiment}
                company={props.company}
                postIndex={props.postIndex}
                updatePostAfterSentimentUpdate={props.updatePostAfterSentimentUpdate}
            />
            <PostFooter
                engagement={true}
                data={props.data}
                postData={props.postData}
                downloadParentPostCsv={props.downloadParentPostCsv}
                setPostSentiment={props.setPostSentiment}
                setCommentSentiment={props.setCommentSentiment}
                company={props.company}
                postIndex={props.postIndex}
                updatePostAfterSentimentUpdate={props.updatePostAfterSentimentUpdate}
            />
        </>
    );
};

export default ModalPostCardData;
